import api from './api';

const revideaUrl = '/revidea';

export function importRevideaImagesApi(instructionId: number, organisationId: number) {
    return api.post(`${revideaUrl}/media`, { instructionId: instructionId, organisationId: organisationId} ).catch(err => {
      console.error(err);
      return err;
    });
  }
